const addPrintListener = (beforePrint, afterPrint) => {
    if (window.matchMedia) {
        const mediaQueryList = window.matchMedia('print');
        mediaQueryList.addListener((mql) => {
            if (mql.matches) {
                beforePrint();
            } else {
                afterPrint();
            }
        });
    } else {
        window.addEventListener('beforeprint', beforePrint);
        window.addEventListener('afterprint', afterPrint);
    }
};

export default addPrintListener;
